import React from 'react';
import { Phone, User, Clock, Eye, CheckCircle } from 'lucide-react';
import { statusConfig } from '../../../config/orderStatus';

const formatTime = (date) => {
    if (!date) return 'Not set';
    const d = new Date(date);
    if (isNaN(d.getTime())) return 'Not set';
    return d.toLocaleDateString() + ' ' + d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

const OrderCard = ({ order, onView, onAction }) => {
    const StatusIcon = statusConfig[order.status]?.icon || Clock;

    return (
        <div className="bg-white rounded-lg shadow hover:shadow-lg transition-shadow p-4 border-l-4 border-blue-500">
            <div className="flex items-start justify-between mb-3">
                <div>
                    <h3 className="font-bold text-lg">{order.id}</h3>
                    <p className="text-sm text-gray-600">{order.customer.name}</p>
                </div>
                <span className={`px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1 ${statusConfig[order.status]?.color}`}>
                    {/* Icon integration requires statusConfig to have components, but mock data has strings? 
                       In original code, icon was a component. In 'data.js' I removed the icon component reference because it can't be serialized easily in JSON if I wanted to.
                       But here I am importing lucide icons. I should map status to icon locally or restore logical mapping.
                   */}
                    {statusConfig[order.status]?.label}
                </span>
            </div>

            <div className="space-y-2 mb-3">
                <div className="flex items-center gap-2 text-sm text-gray-600">
                    <Phone size={14} />
                    {order.customer.phone}
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                    <User size={14} />
                    {order.salesman}
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                    <Clock size={14} />
                    {formatTime(order.deliveryDate || order.createdAt)}
                </div>
            </div>

            <div className="flex gap-2">
                <button
                    onClick={() => onView(order)}
                    className="flex-1 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 flex items-center justify-center gap-2"
                >
                    <Eye size={16} />
                    View Details
                </button>
                {onAction && (
                    <button
                        onClick={() => onAction(order)}
                        className="flex-1 bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 flex items-center justify-center gap-2"
                    >
                        <CheckCircle size={16} />
                        Take Action
                    </button>
                )}
            </div>
        </div>
    );
};

export default OrderCard;
